import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from '../layouts/Header';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';

export interface TermsAndConditionViewProps {

}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            // height: '100vh'
        },
        card: {
            width: '100%',
            marginTop: 32,
            textAlign: 'justify'
        },
        pos: {
            marginBottom: 12,
        },
        italic: {
            fontSize: 'italic'
        }
    })
);

const TermsAndConditionView: React.StatelessComponent<TermsAndConditionViewProps> = props => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Header />
            <CssBaseline />
            <Container maxWidth="lg">
                <Card className={classes.card}>
                    <CardContent>
                        <Typography variant="h5" component="h2">
                            Terms and Condition
                        </Typography>
                        <Typography paragraph gutterBottom>
                            The signature in an agreement of a contract for the sale and delivery (sale of goods and services) of the specialty manufactured products
                            and services mentioned herein and subject to the following terms and conditions:
                        </Typography>
                        <ol>
                            <li>
                                <Typography paragraph>
                                    The customer agrees to pay in-full the stated price of the products and services plus any late payment penalties and
                                    all costs related to collection, including attorney’s fees, if any.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    An invoice is available for each case in the customer login. All statements balances are due and payable within 30 days
                                    of receipt of such statements or as per agreed terms and conditions. Unpaid balances over 30 days will have a 1 ½ % finance charges (18% per annum).
                                    Statements can be paid with Visa, Master Card and American Express.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Each Lab Procedure Prescription (LPP) constitutes a complete and separate transaction to be invoiced and paid as such. Acceptance of a new LPP by Leixir
                                    India does not represent any accord and or satisfaction and does not relieve the dentist of any indebtedness to Leixir India.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Leixir India at times may ask for a deposit and/or ship product on a C.O.D basis.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Leixir India reserves the right to put a credit hold on accounts that are in the arrears and to hold all cases for such account until the account is paid in-full.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Any use, sale, transfer, modification of the product or failure to reasonably notify and return the product within 15 days to Leixir India, shall constitute
                                    acceptance by the customer.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Any defects in returned products will be settled in accordance with the terms and condition of Leixir India product warranty.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    The customer must examine all appliances and determine their fitness for any intended usage.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    There are no express warranties and no Implied Warranty of fitness for a particular purpose given by Leixir India. The only obligation of Leixir India
                                    to repair or replace the appliances and Leixir India shall not be responsible for any Injury, Loss, Lost Shipment or Damage, Direct, Indirect or consequential,
                                    relating to the use or inability to use any products sold by Leixir India.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    There are no express warranties and no Implied Warranty of fitness for a particular purpose given by Leixir India. The only obligation of Leixir India to repair
                                    or replace the appliances and Leixir India shall not be responsible for any Injury, Loss, Lost Shipment or Damage, Direct, Indirect or consequential,
                                    relating to the use or inability to use any products sold by Leixir India.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Privacy Policy: As per the existing privacy policy of the Company.
                                </Typography>
                            </li>
                            <li>
                                <Typography paragraph>
                                    Refund Policy: Leixir India will provide the refund only if the case gets remilled and in no other case. The cost of fabricating our products cannot be refunded.
                                    A credit may be issued by Leixir India directly to a customer's account when cases do not meet our expected standards for quality, function and aesthetics.
                                    Service Fees and parts fees are not refundable unless the product can be returned to the retailer for credit. Refunds on components not manufactured by Leixir
                                    India are pursuant to the individual manufacturer’s return and warranty policies.
                                </Typography>
                            </li>
                        </ol>
                    </CardContent>
                </Card>
            </Container>
        </div >
    );
};

export default TermsAndConditionView;



// WEBPACK FOOTER //
// ./src/components/layouts/TermsAndCondition.tsx